import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import { SpreadsheetComponent } from '@syncfusion/ej2-react-spreadsheet';
import {
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import useNotif from 'hooks/use-notify-hook';

function Table({ answer, scores, isReadonly }) {

  let spreadsheet = useRef(null);

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [data, setData] = useState(answer.ANSWER_DESC);
  const [evaluation, setEvaluation] = useState(answer?.EVALUATE_DESC ?? ``);
  const [attachment, setAttachment] = useState(answer?.answerAttachments?.pop() ?? null);

  const handleCreatedBu = () => {

    if (data === null || data === undefined) return;
    if (!spreadsheet.current) return;

    spreadsheet.current.openFromJson({ file: data });
  }

  const handleCreated = async () => {

    if (data === null || data === undefined) return;
    if (!spreadsheet.current) return;

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}/spreadsheet`,
    );

    spreadsheet.current.openFromJson({file: response.data});
  }

  const [, cancelEvaluation] = useDebounce(async () => {

    const response = await axios.put(
      `${process.env.REACT_APP_API_HOST}answers/${answer.ANSWER_ID}`,
      {
        EVALUATE_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
        EVALUATE_BY: auth.employee.EMP_ID,
        EVALUATE_DESC: evaluation,
      },
      { headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      }
    );

    dispatchNotif({
      place: `br`,
      message: `Update Success...`,
      type: `success`,
    });

  }, 2000, [evaluation]);

  useEffect(() => {
    cancelEvaluation();
  }, []);


  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
            {/* <Card.Title as="h4"><a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} /> */}
            <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap', marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
            <hr></hr>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="10">
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Auditee's Answer</Form.Label>
                  <SpreadsheetComponent
                    ref={spreadsheet}
                    allowEditing={false}
                    showFormulaBar={false}
                    showRibbon={false}
                    showSheetTabs={false}
                    created={handleCreated}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Additional Explanation</Form.Label>
                  <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.ADD_EXPLAN}} />
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Auditor's Evaluation</Form.Label>
                  <p>{answer.EVALUATE_DESC ?? (
                      <span class="text-warning">Not evaluated yet.</span>
                  )}</p>
                </Form.Group>
              </Col>
              <Col md="2">
                <Form.Group>
                  {attachment?.ATTACHMENT_ID ? (
                    <a
                      href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`}
                      className="btn btn-info"
                    >
                      Download
                    </a>
                  ) : (<p>No attachment uploaded.</p>)}
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Score</Form.Label>
                  <p>{scores.find(item => item.INDEX_ID === answer.INDEX_ID)?.INDEX_ID ?? (
                    <span class="text-warning">Not scored yet.</span>
                  )}</p>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default Table;